import humps from 'humps'

import {isEmpty} from 'lodash'
import api from '@/lib/api'

export default {
    namespaced: true,

    state: {
      ndas: [],

      rfields: [
        {key: 'id', label: 'ID', sortable: true},
        {key: 'eventName', label: 'Event', sortable: true},
        {key: 'eventSite', label: 'Site', sortable: true},
        {key: 'webkeyId', label: 'Webkey', sortable: true},
        {key: 'ipc', label: 'Type', sortable: true},
        {key: 'firstName', label: 'First Name', sortable: true},
        {key: 'lastName', label: 'Last Name', sortable: true},
        {key: 'country', label: 'Country', sortable: true},
        {key: 'zone', label: 'Zone', sortable: true},
        {key: 'soldtoId', label: 'Soldto', sortable: true},
        {key: 'soldtoName', label: 'Company', sortable: true},

        {key: 'industry', label: 'SAP Industry', sortable: true},
        {key: 'ndaState', label: 'PRA', sortable: true},
        {key: 'status', label: 'Status', sortable: true},
        {key: 'submitDate', label: 'Submit Date', sortable: true},
      ],
      pfields: [
        //            {key: 'actions', label: '', sortable: true},
        {key: 'soldtoId', label: 'Soldto', sortable: true},
        {key: 'soldtoName', label: 'Company', sortable: true},
        {key: 'startDate', label: 'Effective', sortable: true},
        {key: 'endDate', label: 'Expiration', sortable: true},
        {key: 'templateName', label: 'Template Name', sortable: true},
        {key: 'nda', label: 'PRA', sortable: true},
      ],
    },

    getters: {},

    mutations: {
      ndas: (s, a) =>
        (s.ndas = isEmpty(a)
          ? []
          : humps.camelizeKeys(a, function (key, convert) {
              return /^_.+/.test(key) ? key : convert(key)
            })),
    },

    actions: {
        async fetchNDAs({commit}) {
          try {
            let variants = {
              '': '',
              AC: '',
              WA: 'warning',
              BA: 'danger'
            };

            let resp = await api.nda.dashboard();
            let data = resp.data.map((row) => {
              if (row.content.soldto.notes.length) {
                row['_rowVariant'] = variants[row.content.soldto.notes[0].status.value];
              }
              return row;
            });

            commit('ndas', data);
          } catch (e) {
            commit('ndas', []);
          }
        },
        async fetchDashboardNDAs({commit}, q) {
            try {
                let variants = {
                  '': '',
                  AC: '',
                  WA: 'warning',
                  BA: 'danger'
                };

              let resp = await api.nda.list(q);

              let data = resp.data.map((row) => {
                if (row.content.soldto.notes.length) {
                  row['_rowVariant'] = variants[row.content.soldto.notes[0].status.value];
                }
                return row;
              });

              commit('ndas', data);
            } catch (e) {
                commit('ndas', []);
            }
        }
    }
}
